module.exports = __webpack_public_path__ + "img/build_faded.0684f656.png";